module.exports = "<div class=\"page-content\">\n  <!-- <h1>Hello</h1> -->\n</div>\n"